"use client";
import React from "react";

export type DrawerBackCtx = {
  setDrawerBack: (handler: (() => void) | null) => void;
};

export const DrawerBackContext = React.createContext<DrawerBackCtx>({
  setDrawerBack: () => {},
});

/** Hook for children to register/unregister a back handler in the drawer header. */
export function useDrawerBack() {
  return React.useContext(DrawerBackContext);
}
